// ============================================================================
// SIEVE OF ERATOSTHENES - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'sieve-of-eratosthenes',
  name: 'Sieve of Eratosthenes',
  category: 'Math',
  complexity: {
    time: 'O(N log log N)',
    space: 'O(N)'
  },
  description: 'An ancient algorithm for finding all prime numbers up to a specified integer. It iteratively marks multiples of each prime starting from 2, leaving only unmarked numbers as primes.'
};
